export default __webpack_public_path__ + "d467be61e12d77d804dd60451b9a6376.svg";